import React from "react";
import SkillBuildingbanner from "../../AVHRBanner/Skillsbanner.png";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import SkilsBuilding from "../../Images/SkillbuildingOneimg.png";
import SkilsBuildingtwo from "../../Images/SkillsBuildtwo.jpg"
import { FaCheckCircle } from "react-icons/fa";

function SkillBuilding() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const points = [
  "😌 Stress and Emotion Management – Handle academic pressure with confidence",
  "⏳ Time Management – Organize, prioritize, and achieve goals effectively",
  "🧠 Critical Thinking – Make smarter decisions and sharpen your mindset",
  "🗣️ Active Listening & Communication – Boost clarity in learning and expression",
  "📝 Exam and Test-Taking Strategies – Learn how to approach exams strategically",
  "🎯 Attention to Detail – Improve focus and accuracy in every task",
  "💰 Financial Literarcy - Understand financial concept and its importance in life",
];


const pointstwo = [
  "🎙️ Live Interactive Sessions with experienced coaches",
  "🧠 Webinars and Workshops",
  "✍️ Worksheets and Activities to reinforce learning ",
  "📊 Progress Reports to track growth",
  "📝  Assessments to measure improvement",
  "🎓 Certification upon successful completion",
];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner-H">
          <img
            src={SkillBuildingbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest avhrProject-bannerTextColour-B">
            <div className="text-bannar max-w-3xl text-left">
              <p className="edu-support-text uppercase" >Our Edu Support</p>

              <h1 className="career-library-heading">Skill Building</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">
              Empower Your Future with Essential Skills
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{fontSize: "20px"}}>
              We offer targeted training programs to develop technical and soft
              skills for today’s competitive world
            </p>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2"
          style={{ backgroundColor: "#FEFDED" }}
        >
          {/* Image */}
          <div className="col-12 md:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={SkilsBuilding}
              alt=""
              className="w-full border-round-lg shadow-4"
            />
          </div>

          {/* Content */}
          <div className="col-12 md:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">
              Why Skill Building Matters
            </h2>
            <ul className="list-none pl-4">
              {points.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2 mt-4"
          style={{ backgroundColor: "#FDF6EC" }}
        >
          {/* Content */}
          <div className="col-12 md:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">
              What Students Can Expect
            </h2>
            <ul className="list-none pl-4">
              {pointstwo.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="col-12 md:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={SkilsBuildingtwo}
              alt=""
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(120deg, #FF9066, #FFD96A, #FFF7DC)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">
              📢 Ready to Empower the Next Generation
            </p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              We want you to thrive — in school and beyond
            </h2>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default SkillBuilding;
